const DEFAULT_COUNTRY = 'Australia';

export const AUSTRALIAN_STATES = ['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA'];

export const toManualAddress = (fullAddress, currentAddress, withState = false) => ({
  fullAddress,
  country: currentAddress?.country ?? DEFAULT_COUNTRY,
  ...(withState && currentAddress?.state ? { state: currentAddress.state } : {}),
});

export const getModeChangeAddress = (isCustomAddress, currentAddress) => (
  isCustomAddress ? toManualAddress(currentAddress?.fullAddress ?? '', currentAddress) : null
);

export const isManualAddress = (address) => !!address?.fullAddress
  && !(address.street || address.number || address.locality || address.postcode);

export const getAddressSearchError = ({ address, isCustomAddress, searchString, isValidationActive, requiredMessage }) => {
  if (!!address?.fullAddress || !isValidationActive) return null;
  if (isCustomAddress || !searchString) return requiredMessage;
  if (searchString.length < 3) return 'Must be at least 3 characters';
  if (searchString.length > 500) return 'You have exceeded the maximum number of 500 characters';
  return requiredMessage;
};
